import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Table, Button, Form, InputGroup, Badge, Spinner, Modal, Pagination } from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const DataKlasifikasi = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState({ date: '', clock: '' });

  // Data Klasifikasi State
  const [klasifikasiList, setKlasifikasiList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Form State untuk Input/Edit Modal
  const [formKdKlas, setFormKdKlas] = useState('');
  const [formNmKlas, setFormNmKlas] = useState('');
  const [formAdm, setFormAdm] = useState(0);
  const [formAdmLabRI, setFormAdmLabRI] = useState(0);
  const [formAdmLabRJ, setFormAdmLabRJ] = useState(0);
  const [formAdmRadRI, setFormAdmRadRI] = useState(0);
  const [formAdmRadRJ, setFormAdmRadRJ] = useState(0);
  const [formAdmRp, setFormAdmRp] = useState(0);
  const [formBayar, setFormBayar] = useState('Tunai');
  const [formFlagObat, setFormFlagObat] = useState('X');
  const [formMarginA, setFormMarginA] = useState(0);
  const [formMarginF, setFormMarginF] = useState(0);
  const [formPemasaran, setFormPemasaran] = useState(0);
  const [formPerlengkapan, setFormPerlengkapan] = useState(0);
  const [formToeslagA, setFormToeslagA] = useState(0);
  const [formToeslagF, setFormToeslagF] = useState(0);
  const [formTglNonaktif, setFormTglNonaktif] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);

  // Fallback Mock Data matching requested response JSON
  const mockKlasifikasi = [
    {
      "adm": 5.0,
      "admlabri": 10000,
      "admlabrj": 10000,
      "admradri": 10000,
      "admradrj": 10000,
      "admrp": 0,
      "bayar": "Tunai",
      "flag_obat": "X",
      "kd_klas": "001",
      "margina": 1.3,
      "marginf": 1.5,
      "nm_klas": "Pribadi",
      "pemasaran": 0.0,
      "perlengkapan": 0,
      "tgl_nonaktif": "27/01/2014",
      "toeslaga": 2500,
      "toeslagf": 2500
    },
    {
      "adm": 5.0,
      "admlabri": 0,
      "admlabrj": 0,
      "admradri": 0,
      "admradrj": 0,
      "admrp": 0,
      "bayar": "Tunai",
      "flag_obat": "X",
      "kd_klas": "002",
      "margina": 0.0,
      "marginf": 0.0,
      "nm_klas": "Rekanan",
      "pemasaran": 20.0,
      "perlengkapan": 0,
      "tgl_nonaktif": "10/03/2014",
      "toeslaga": 0,
      "toeslagf": 0
    }
  ];

  // Fetch data klasifikasi dari backend /show_klasifikasi
  const fetchKlasifikasi = async () => {
    setIsLoading(true);
    setFetchError('');
    const apiUrl = getApiUrl();
    try {
      const response = await fetch(`${apiUrl}/show_klasifikasi`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const json = await response.json();
      if (json && json.list_klasifikasi) {
        setKlasifikasiList(json.list_klasifikasi);
      } else {
        setKlasifikasiList(mockKlasifikasi);
      }
    } catch (err) {
      console.warn("Gagal terhubung ke backend /show_klasifikasi, menggunakan data lokal:", err);
      setKlasifikasiList(mockKlasifikasi);
      setFetchError("Menggunakan data lokal. Gagal terhubung ke server backend.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);

    fetchKlasifikasi();

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter List Klasifikasi
  const filteredKlasifikasi = klasifikasiList.filter(item => {
    const matchesSearch = 
      ((item.nm_klas || '').toLowerCase().includes(searchQuery.toLowerCase())) ||
      ((item.kd_klas || '').toLowerCase().includes(searchQuery.toLowerCase())) ||
      ((item.bayar || '').toLowerCase().includes(searchQuery.toLowerCase()));

    return matchesSearch;
  });

  // Paginated List
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredKlasifikasi.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredKlasifikasi.length / itemsPerPage);

  // Pilih untuk di-edit
  const handleSelectEdit = (item) => {
    setFormKdKlas(item.kd_klas || '');
    setFormNmKlas(item.nm_klas || '');
    setFormAdm(item.adm ?? 0);
    setFormAdmLabRI(item.admlabri ?? 0);
    setFormAdmLabRJ(item.admlabrj ?? 0);
    setFormAdmRadRI(item.admradri ?? 0);
    setFormAdmRadRJ(item.admradrj ?? 0);
    setFormAdmRp(item.admrp ?? 0);
    setFormBayar(item.bayar || 'Tunai');
    setFormFlagObat(item.flag_obat || 'X');
    setFormMarginA(item.margina ?? 0);
    setFormMarginF(item.marginf ?? 0);
    setFormPemasaran(item.pemasaran ?? 0);
    setFormPerlengkapan(item.perlengkapan ?? 0);
    setFormToeslagA(item.toeslaga ?? 0);
    setFormToeslagF(item.toeslagf ?? 0);
    setFormTglNonaktif(item.tgl_nonaktif || '');
    setIsEditing(true);
    setShowFormModal(true);
  };

  // Bersihkan form
  const handleClearForm = () => {
    setFormKdKlas('');
    setFormNmKlas('');
    setFormAdm(0);
    setFormAdmLabRI(0);
    setFormAdmLabRJ(0);
    setFormAdmRadRI(0);
    setFormAdmRadRJ(0);
    setFormAdmRp(0);
    setFormBayar('Tunai');
    setFormFlagObat('X');
    setFormMarginA(0);
    setFormMarginF(0);
    setFormPemasaran(0);
    setFormPerlengkapan(0);
    setFormToeslagA(0);
    setFormToeslagF(0);
    setFormTglNonaktif('');
    setIsEditing(false);
    setShowFormModal(false);
  };

  // Submit Simpan (Lokal)
  const handleSubmit = (e) => {
    e.preventDefault();
    const newRecord = {
      kd_klas: formKdKlas || `KL-${Math.floor(Math.random() * 1000)}`,
      nm_klas: formNmKlas,
      adm: parseFloat(formAdm),
      admlabri: parseInt(formAdmLabRI, 10),
      admlabrj: parseInt(formAdmLabRJ, 10),
      admradri: parseInt(formAdmRadRI, 10),
      admradrj: parseInt(formAdmRadRJ, 10),
      admrp: parseInt(formAdmRp, 10),
      bayar: formBayar,
      flag_obat: formFlagObat,
      margina: parseFloat(formMarginA),
      marginf: parseFloat(formMarginF),
      pemasaran: parseFloat(formPemasaran),
      perlengkapan: parseInt(formPerlengkapan, 10),
      toeslaga: parseInt(formToeslagA, 10),
      toeslagf: parseInt(formToeslagF, 10),
      tgl_nonaktif: formTglNonaktif || null
    };

    if (isEditing) {
      setKlasifikasiList(prev => prev.map(k => k.kd_klas === formKdKlas ? newRecord : k));
    } else {
      setKlasifikasiList(prev => [...prev, newRecord]);
    }
    handleClearForm();
  };

  // Hapus Data (Lokal)
  const handleDelete = (kdKlas) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus data klasifikasi ini?")) {
      setKlasifikasiList(prev => prev.filter(k => k.kd_klas !== kdKlas));
    }
  };

  return (
    <div style={styles.appContainer}>
      {/* ══════════════ NAVBAR ══════════════ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home" onClick={(e) => { e.preventDefault(); navigate('/home'); }}>
            <div className="d-flex align-items-center justify-content-center me-2 rounded bg-white bg-opacity-10 p-1">
              <i className="bi bi-shield-plus text-warning fs-4"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem' }}>SIMRS2 <span className="text-teal" style={{ fontSize: '0.78rem' }}>Finance</span></div>
              <div className="text-white-50 small" style={{ fontSize: '0.62rem' }}>Sistem Informasi Rumah Sakit</div>
            </div>
          </a>

          <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
            <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
              <div className="fw-semibold text-white-50" style={{ fontSize: '0.73rem' }}>{time.date}</div>
              <div className="fw-bold text-teal" style={{ fontSize: '0.78rem' }}>{time.clock}</div>
            </div>
            
            <Button variant="light" size="sm" onClick={() => navigate('/home')} className="d-flex align-items-center gap-1">
              <i className="bi bi-house-door-fill text-teal"></i>
              <span>Kembali</span>
            </Button>
          </div>
        </Container>
      </nav>

      {/* ══════════════ CORE MAIN CONTENT ══════════════ */}
      <div style={styles.mainContent}>
        <Row className="g-3">
          
          <Col lg={12}>
            <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
              <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }} className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <span className="fw-bold"><i className="bi bi-tags me-1 text-warning"></i> Tabel Master Data Klasifikasi</span>
                <div className="d-flex gap-2 align-items-center">
                  <Button variant="teal" size="sm" onClick={() => { handleClearForm(); setShowFormModal(true); }} className="d-flex align-items-center gap-1.5 fw-bold px-3 py-1.5" style={{ fontSize: '0.73rem', background: '#0d9488', border: 'none' }}>
                    <i className="bi bi-plus-circle-fill"></i> Buat Klasifikasi Baru
                  </Button>
                  <Button variant="outline-light" size="sm" onClick={fetchKlasifikasi} disabled={isLoading} style={{ fontSize: '0.7rem' }}>
                    {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                  </Button>
                </div>
              </div>

              <Card.Body className="p-2 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                {/* Search Bar & Limit Row */}
                <Row className="g-2 mb-3">
                  <Col md={8}>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light text-muted border-slate"><i className="bi bi-search"></i></InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Cari Klasifikasi (Kode, Nama, Cara Bayar)..."
                        value={searchQuery}
                        onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                        style={{ fontSize: '0.78rem' }}
                      />
                    </InputGroup>
                  </Col>

                  <Col md={4}>
                    <Form.Select 
                      size="sm" 
                      value={itemsPerPage} 
                      onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value={10}>10 Baris</option>
                      <option value={20}>20 Baris</option>
                      <option value={50}>50 Baris</option>
                      <option value={100}>100 Baris</option>
                    </Form.Select>
                  </Col>
                </Row>

                {/* Table Area */}
                {fetchError && (
                  <div className="alert alert-warning py-1.5 px-3 mb-2.5" style={{ fontSize: '0.75rem' }}>
                    <i className="bi bi-exclamation-triangle-fill me-1"></i> {fetchError}
                  </div>
                )}

                <div className="table-responsive flex-grow-1" style={{ overflowY: 'auto', minHeight: '380px' }}>
                  <Table responsive striped bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
                    <thead className="table-light text-secondary sticky-top">
                      <tr>
                        <th style={{ width: '80px' }}>Kode</th>
                        <th>Nama Klasifikasi</th>
                        <th>Cara Bayar</th>
                        <th>Adm (%)</th>
                        <th>Adm Lab (RI/RJ)</th>
                        <th>Adm Rad (RI/RJ)</th>
                        <th>Toeslag Apotek/Farmasi</th>
                        <th>Margin A/F</th>
                        <th>Status</th>
                        <th style={{ width: '100px' }} className="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="10" className="text-center py-5 text-muted">
                            <Spinner animation="border" variant="teal" className="mb-2" />
                            <div>Memuat data klasifikasi...</div>
                          </td>
                        </tr>
                      ) : currentItems.length > 0 ? (
                        currentItems.map((item, idx) => (
                          <tr key={idx}>
                            <td className="fw-bold text-dark-blue">{item.kd_klas}</td>
                            <td className="fw-bold">{item.nm_klas}</td>
                            <td>
                              <Badge bg={item.bayar === 'Tunai' ? 'success' : 'primary'} style={styles.badgeStyle}>
                                {item.bayar}
                              </Badge>
                            </td>
                            <td>{item.adm}% (Rp {item.admrp || 0})</td>
                            <td>
                              <div>RI: Rp {item.admlabri?.toLocaleString('id-ID')}</div>
                              <div>RJ: Rp {item.admlabrj?.toLocaleString('id-ID')}</div>
                            </td>
                            <td>
                              <div>RI: Rp {item.admradri?.toLocaleString('id-ID')}</div>
                              <div>RJ: Rp {item.admradrj?.toLocaleString('id-ID')}</div>
                            </td>
                            <td>
                              <div>Apotek: Rp {item.toeslaga?.toLocaleString('id-ID')}</div>
                              <div>Farmasi: Rp {item.toeslagf?.toLocaleString('id-ID')}</div>
                            </td>
                            <td>
                              <div>A: {item.margina}</div>
                              <div>F: {item.marginf}</div>
                            </td>
                            <td>
                              {item.tgl_nonaktif ? (
                                <Badge bg="danger" style={styles.badgeStyle}>Non-Aktif ({item.tgl_nonaktif})</Badge>
                              ) : (
                                <Badge bg="success" style={styles.badgeStyle}>Aktif</Badge>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-1">
                                <Button size="sm" variant="outline-primary" onClick={() => handleSelectEdit(item)} style={styles.actionBtn}>
                                  <i className="bi bi-pencil-fill"></i>
                                </Button>
                                <Button size="sm" variant="outline-danger" onClick={() => handleDelete(item.kd_klas)} style={styles.actionBtn}>
                                  <i className="bi bi-trash-fill"></i>
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center py-4 text-muted">
                            Tidak ada data klasifikasi yang cocok.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                      <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                      {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                      <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                  </div>
                )}

                {/* Footer Info */}
                <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top text-muted small" style={{ fontSize: '0.72rem' }}>
                  <span>
                    Menampilkan <strong>{filteredKlasifikasi.length > 0 ? indexOfFirstItem + 1 : 0} - {Math.min(indexOfLastItem, filteredKlasifikasi.length)}</strong> dari <strong>{filteredKlasifikasi.length}</strong> data (Total: {klasifikasiList.length})
                  </span>
                  <span>IP Server: <strong>{getApiUrl()}</strong></span>
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </div>

      {/* ══════════════ MODAL FORM ENTRI/EDIT DATA KLASIFIKASI ══════════════ */}
      <Modal show={showFormModal} onHide={handleClearForm} centered backdrop="static" size="lg">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#ffffff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-pencil-square text-warning fs-5"></i>
            <span>{isEditing ? `Edit Klasifikasi: ${formNmKlas}` : 'Buat Klasifikasi Baru'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSubmit}>
            <Row className="g-2 mb-2.5">
              {/* Kode Klasifikasi */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode Klas (kd_klas)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: 003"
                    value={formKdKlas}
                    onChange={(e) => setFormKdKlas(e.target.value)}
                    disabled={isEditing}
                    required
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Nama Klasifikasi */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Klasifikasi (nm_klas)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: Pribadi / BPJS / Rekanan"
                    value={formNmKlas}
                    onChange={(e) => setFormNmKlas(e.target.value)}
                    required
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Cara Bayar */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Cara Bayar</Form.Label>
                  <Form.Select 
                    value={formBayar} 
                    onChange={(e) => setFormBayar(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="Tunai">Tunai</option>
                    <option value="Kredit">Kredit</option>
                    <option value="Asuransi">Asuransi</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-2.5">
              {/* Adm Persen */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Adm (%)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={formAdm}
                    onChange={(e) => setFormAdm(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Adm Rupiah */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Adm (Rp)</Form.Label>
                  <Form.Control
                    type="number"
                    value={formAdmRp}
                    onChange={(e) => setFormAdmRp(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Flag Obat */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Flag Obat</Form.Label>
                  <Form.Select 
                    value={formFlagObat} 
                    onChange={(e) => setFormFlagObat(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="X">Tidak (X)</option>
                    <option value="V">Ya (V)</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Pemasaran */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Pemasaran (%)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={formPemasaran}
                    onChange={(e) => setFormPemasaran(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-2.5">
              {/* Adm Lab RI */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Adm Lab RI</Form.Label>
                  <Form.Control
                    type="number"
                    value={formAdmLabRI}
                    onChange={(e) => setFormAdmLabRI(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Adm Lab RJ */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Adm Lab RJ</Form.Label>
                  <Form.Control
                    type="number"
                    value={formAdmLabRJ}
                    onChange={(e) => setFormAdmLabRJ(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Adm Rad RI */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Adm Rad RI</Form.Label>
                  <Form.Control
                    type="number"
                    value={formAdmRadRI}
                    onChange={(e) => setFormAdmRadRI(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Adm Rad RJ */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Adm Rad RJ</Form.Label>
                  <Form.Control
                    type="number"
                    value={formAdmRadRJ}
                    onChange={(e) => setFormAdmRadRJ(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-2.5">
              {/* Margin A */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Margin A</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={formMarginA}
                    onChange={(e) => setFormMarginA(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Margin F */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Margin F</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={formMarginF}
                    onChange={(e) => setFormMarginF(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Toeslag Apotek */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Toeslag Apotek</Form.Label>
                  <Form.Control
                    type="number"
                    value={formToeslagA}
                    onChange={(e) => setFormToeslagA(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Toeslag Farmasi */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Toeslag Farmasi</Form.Label>
                  <Form.Control
                    type="number"
                    value={formToeslagF}
                    onChange={(e) => setFormToeslagF(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-3">
              {/* Perlengkapan */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Perlengkapan (Rp)</Form.Label>
                  <Form.Control
                    type="number"
                    value={formPerlengkapan}
                    onChange={(e) => setFormPerlengkapan(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Tgl Non-Aktif */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Tanggal Non-Aktif (tgl_nonaktif)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: 27/01/2014"
                    value={formTglNonaktif}
                    onChange={(e) => setFormTglNonaktif(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Actions */}
            <div className="d-flex justify-content-end gap-2 border-top pt-2.5">
              <Button type="button" variant="secondary" size="sm" onClick={handleClearForm}>
                Batal
              </Button>
              <Button type="submit" variant="teal" size="sm" className="fw-bold" style={styles.btnSave}>
                <i className="bi bi-hdd-fill me-1"></i> Simpan
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex',
    flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.25rem 1rem',
    flexShrink: 0,
  },
  mainContent: {
    flex: 1,
    padding: '0.4rem',
    overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '12px',
    border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff',
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.4rem 0.75rem',
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
  formControl: {
    fontSize: '0.75rem',
    borderRadius: '6px',
    padding: '0.35rem 0.6rem',
    border: '1px solid #cbd5e1',
    color: '#0f172a',
  },
  formSelect: {
    fontSize: '0.75rem',
    borderRadius: '6px',
    padding: '0.35rem 0.6rem',
    border: '1px solid #cbd5e1',
    color: '#0f172a',
  },
  btnSave: {
    background: '#0d9488',
    borderColor: '#0d9488',
    color: '#ffffff',
    fontSize: '0.78rem',
  },
  actionBtn: {
    padding: '0.2rem 0.4rem',
    fontSize: '0.7rem',
  },
  badgeStyle: {
    fontSize: '0.7rem',
    fontWeight: '600',
    padding: '3px 7px',
    borderRadius: '20px',
  }
};

export default DataKlasifikasi;
